import React from 'react';
import { useTranslation } from 'react-i18next';
import { Controller, useForm } from "react-hook-form";

import { InputText } from 'primereact/inputtext';
import { Button } from '../../../../../../components/ui/Button';

const LayoutNameController = ({ layoutName, setLayoutName, titleError }) => {
    const { t } = useTranslation();
    const { control, handleSubmit, reset } = useForm({
        defaultValues: { layoutName: layoutName?.name || "" },
        mode: "onBlur"
    });

    // Update form when external name changes
    React.useEffect(() => {
        reset({ layoutName: layoutName?.name || "" });
    }, [layoutName?.name, reset]);

    const onTitleSubmit = (data) => {
        if (data.layoutName !== layoutName.name) {
            setLayoutName({ isEditing: false, name: data.layoutName });
        }
    };

    return (
        <form className="w-full max-w-[320px] mx-auto" onSubmit={handleSubmit(onTitleSubmit)}>
            <Controller
                name="layoutName"
                control={control}
                rules={{
                    required: t('layouts.designer_title_required'),
                    minLength: { value: 3, message: t('layouts.designer_min_3_chars') }
                }}
                render={({ field, fieldState }) => (
                    <div className="relative group">
                        <InputText
                            {...field}
                            autoComplete="off"
                            onBlur={handleSubmit(onTitleSubmit)}
                            placeholder={t('layouts.designer_untitled_layout')}
                            className={`w-full text-center text-sm font-semibold transition-all duration-200 rounded-md py-1.5 px-3
                                ${fieldState.error 
                                    ? "bg-red-50 text-red-900 border border-red-200 focus:ring-2 focus:ring-red-100 placeholder:text-red-300" 
                                    : "bg-white text-gray-900 border border-gray-300 hover:border-gray-400 focus:border-indigo-500 focus:ring-4 focus:ring-indigo-500/10 placeholder:text-gray-400 shadow-sm"
                                }
                            `}
                        />
                        {/* Edit Icon Hint (Only visible on hover when not focused) */}
                        <div className="absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity text-gray-400 peer-focus:opacity-0">
                            <i className="bx bx-pencil text-[10px]"></i>
                        </div>
                    </div>
                )}
            />
        </form>
    );
};

export default LayoutNameController;
